/**
 * Cart add error recovery
 *
 * Context: Noibu issue #1 — "422 Unprocessable Entity" on /cart/add.js,
 * observed on /products/cheese-cake (Apr 16), where every affected shopper
 * had clicked the add-to-cart button.
 *
 * The theme already surfaces Shopify's rejection message under the product
 * form (see _addItemToCart's fail handler in assets/theme.js). What it does
 * NOT do is update the button state: after a 422 the button still reads
 * "Add to cart", inviting shoppers to retry an add that cannot succeed —
 * for example when the variant sold out after the page was loaded.
 *
 * This script listens for failed /cart/add.js requests. On HTTP 422 it
 * re-checks the submitted variant's live availability via the public
 * product JSON endpoint and, if the variant is no longer available, flips
 * the product form button to the theme's sold-out state (same attributes
 * the theme sets when a sold-out variant is selected).
 *
 * Additive and self-contained on purpose: it does not modify theme.js and
 * fails silently if its expectations aren't met.
 */

(function($) {
  if (!$) return;

  $(document).ajaxError(function(event, xhr, settings) {
    if (!settings || !settings.url || settings.url.indexOf('/cart/add') === -1) {
      return;
    }
    if (!xhr || xhr.status !== 422) return;

    var pathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!pathMatch) return;

    var submittedId = null;
    if (typeof settings.data === 'string') {
      var idMatch = settings.data.match(/(?:^|&)id=(\d+)/);
      if (idMatch) submittedId = parseInt(idMatch[1], 10);
    }
    if (!submittedId) return;

    $.getJSON('/products/' + pathMatch[1] + '.js').done(function(product) {
      var variant = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id === submittedId) {
          variant = product.variants[i];
          break;
        }
      }

      if (!variant || variant.available) return;

      var soldOut =
        (window.theme && theme.strings && theme.strings.soldOut) || 'Sold out';

      $('[data-add-to-cart]')
        .attr('aria-disabled', true)
        .attr('aria-label', soldOut)
        .prop('disabled', true);
      $('[data-add-to-cart-text]').text(soldOut);
    });
  });
})(window.jQuery);
